module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/fonts/glyphicons-halflings-regular.woff
 ** module id = 755
 ** module chunks = 1
 **/